import {PageTitle} from '_metronic/layout/core'
import {FC, useState, useEffect, Fragment} from 'react'

import './style.css'
import RegisterModal from './RegisterModal'
import AlertUpdateProfileModal from './AlertUpdateProfileModal'
import UpdateProfileModal from './UpdateProfileModal'
import GuideModal from './GuideModal'
import Api from '../../../thesis-and-dissertations/helpers/api'
import handleApiError from 'thesis-and-dissertations/helpers/handleApiError'
import {toast} from 'react-toastify'
import {useNavigate} from 'react-router-dom'
import HTMLRenderer from 'react-html-renderer'
import Image from '../../assets/img/bg-profile-pana.png'
import ImageCover from '../../assets/img/bg-cover.png'
import ImageNote from '../../assets/img/agenda.png'
import CountDown from './CountDown'
import AnnouncementModal from './AnnouncementModal'
const api = new Api()

const BerandaPage: FC = () => {
  const navigate = useNavigate()
  const [showAlertUpdateModal, setShowAlertUpdateModal] = useState(false)
  const [showUpdateProfileModal, setShowUpdateProfileModal] = useState(false)
  const [showGuideModal, setShowGuideModal] = useState(false)
  const [showRegisterModal, setShowRegisterModal] = useState(false)
  const [themeList, setThemeList] = useState<any>([])
  const [dataPana, setDataPana] = useState<any>([])
  const [serverTime, setServerTime] = useState<any>({})
  const [asTeam, setasTeam] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [showAnnouncementModal, setShowAnnouncementModal] = useState<boolean>(false)

  useEffect(() => {
    getTheme()
    getPana()
    checkPana()
    getTimeServer()

    const currentLogin = JSON.parse(localStorage.getItem('kt-auth-react-v') || '')
    let lastUserId = localStorage.getItem('lastUserId')

    if (currentLogin.users_id != lastUserId) {
      //check locat storage jika tidak sesuai data milik nya
      removeLocalStorageItems([
        'currentStep',
        'ringkasan_proposal',
        'ringkasan_proposal_2',
        'judul_proposal',
        'judul_proposal_2',
      ])
    }
  }, [])

  const removeLocalStorageItems = (keys: any) => {
    keys.forEach((key: any) => localStorage.removeItem(key))
  }

  const handleShowUpdateProfileModal = (action: boolean) => {
    setShowUpdateProfileModal(action)
  }

  const handleShowGuideModal = (action: boolean) => {
    setShowGuideModal(action)
  }

  const handleShowRegisterModal = (action: boolean) => {
    setShowRegisterModal(action)
  }

  const handleCloseRegisterModal = (action: boolean) => {
    setShowRegisterModal(action)
  }

  const getTimeServer = () => {
    api
      .getTimeServer()
      .then((response: any) => {
        const {data} = response
        setServerTime(data)
        // localStorage.setItem('serverTime', JSON.stringify(data))
      })
      .catch((error: any) => {
        handleApiError(error, navigate)
      })
  }

  const getTheme = () => {
    api
      .getThemeList()
      .then((response: any) => {
        // Handle berbagai kemungkinan struktur response
        let themeData = []
        if (response.data?.data?.data) {
          // Struktur: { data: { data: [...] } }
          themeData = response.data.data.data
        } else if (response.data?.data && Array.isArray(response.data.data)) {
          // Struktur: { data: [...] }
          themeData = response.data.data
        } else if (Array.isArray(response.data)) {
          // Struktur langsung array
          themeData = response.data
        }
        
        setThemeList(themeData)
      })
      .catch((error: any) => {
        handleApiError(error, navigate)
      })
  }

  const checkPana = () => {
    // Gabungkan check dari API checkPana dan getProfile untuk validasi lengkap
    api
      .checkPana()
      .then((response: any) => {
        const {data} = response.data

        // Jika flag is_pembaruan_profile false, langsung tampilkan popup
        if (!data?.is_pembaruan_profile) {
          setShowAlertUpdateModal(true)
          return
        }

        // Jika flag true, cek lagi dari profile apakah rekening sudah diisi
        api
          .getProfile()
          .then((profileResponse: any) => {
            const profileData = profileResponse.data?.data
            
            // Popup muncul jika nomor atau nama rekening kosong
            if (!profileData?.detail?.no_rekening || !profileData?.detail?.nama_rekening) {
              setShowAlertUpdateModal(true)
            }
          })
          .catch((error: any) => {
            // Error fetching profile
          })
      })
      .catch((error: any) => {
        handleApiError(error, navigate)
      })
  }

  const getPana = () => {
    setLoading(true)
    api
      .getRegisterPana()
      .then((response: any) => {
        setLoading(false)
        const {data} = response.data
        setDataPana(data)

        if (data?.is_selesai == 1) {
          setShowRegisterModal(false)
        }

        let showAnnouncementModal = localStorage.getItem('showAnnouncementModal')
        if (
          (data?.waktu_publish || data?.waktu_publish_wawancara) &&
          showAnnouncementModal == null
        ) {
          getPublishTime()
        }
      })
      .catch((error: any) => {
        setLoading(false)
        const {data, status} = error.response

        handleApiError(error, navigate)
        toast.error(data?.meta?.message)
      })
  }

  const getPublishTime = () => {
    setLoading(true)
    api
      .getPublisTimeStatus()
      .then((response: any) => {
        setLoading(false)
        const {data} = response.data

        if (data?.kelulusan_publish == true || data?.wawancara_publish == true) {
          setShowAnnouncementModal(true)
        }
      })
      .catch((error: any) => {
        setLoading(false)
        const {data, status} = error.response

        handleApiError(error, navigate)
        toast.error(data?.meta?.message)
      })
  }

  return (
    <>
      <AnnouncementModal showAlertModal={showAnnouncementModal} />

      <AlertUpdateProfileModal
        showAlertUpdateModal={showAlertUpdateModal}
        handleShowUpdateProfileModal={handleShowUpdateProfileModal}
      />

      <GuideModal showGuideModal={showGuideModal} handleShowGuideModal={handleShowGuideModal} />

      <UpdateProfileModal showUpdateProfileModal={showUpdateProfileModal} />

      <RegisterModal
        showRegisterModal={showRegisterModal}
        handleCloseRegisterModal={handleCloseRegisterModal}
      />

      <div className='col-md-12'>
        {themeList[0]?.tanggal_akhir ? (
          <CountDown endDate={themeList[0]?.tanggal_akhir} serverTime={serverTime?.server_time} />
        ) : null}

        <div
          style={{
            borderRadius: '6.18px',
            backgroundColor: '#F95E2F',
            backgroundImage: `url(${ImageCover})`,
            backgroundPosition: 'calc(100% - 10px) 0',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
          }}
        >
          <div className='text-white display-6 p-10 fw-normal'>
            <p>Selamat Datang</p>
            <p className='mb-12'>Para Alumni LPDP</p>
          </div>
        </div>

        <div className='mt-8'>
          <p className='h4 pb-3'>Status Pendaftaran</p>

          {dataPana && Object.keys(dataPana).length > 0 ? (
            <div className='px-5 py-7 mt-3' style={{background: '#FFFFFF', borderRadius: '6.18px'}}>
              <div
                className='p-5 row'
                style={{
                  backgroundImage: `url(${Image})`,
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: 'cover',
                  border: '1px solid #D8DCE8',
                  borderRadius: '15px',
                  backgroundPosition: 'center',
                }}
              >
                <div className='col-md-10 col-sm-12 col-xs-12'>
                  <div className='d-flex justify-content-start'>
                    <div style={{marginLeft: '15px'}} className='mt-2'>
                      <img
                        src={require('../../assets/img/avatar-pana.png')}
                        alt='PANA'
                        id='avatar-image'
                      />
                    </div>

                    <div className='p-5'>
                      {dataPana?.pendaftaran_locus_temas?.length > 0 ? (
                        dataPana.pendaftaran_locus_temas.map((item: any, key: any) => {
                          if (item?.prioritas == 1) {
                            return (
                              <span className='h6' key={key}>
                                <HTMLRenderer html={item?.locus?.tema?.tema ?? ''} />
                              </span>
                            )
                          }
                        })
                      ) : (
                        <span className='h6'>{dataPana?.judul_proposal || 'Pendaftaran PANA'}</span>
                      )}

                      <p style={{textTransform: 'capitalize'}}>
                        {dataPana?.tipe || 'individu'} &#x2022; {dataPana?.nomor_pendaftaran ?? 'Belum ada nomor'} &#x2022;{' '}
                        {'   '}
                        {dataPana?.is_selesai == 1 ? (
                          <span className='badge' style={{backgroundColor: '#64748B', color: '#fff'}}>Berhasil Pendaftaran</span>
                        ) : (
                          <span className='badge badge-warning'>Draft - Belum Selesai</span>
                        )}
                      </p>
                    </div>
                  </div>
                </div>

                <div className='col-md-2 col-sm-12 col-xs-12'>
                  <div className='mt-3 mt-md-0 align-self-md-center text-end w-100 w-md-auto'>
                    <button
                      onClick={() => navigate('/my-pana')}
                      className='btn btn-primary btn-sm mt-9'
                    >
                      {dataPana?.is_selesai == 1 ? 'Detail' : 'Lanjutkan'}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div
              style={{background: '#FFFFFF', borderRadius: '6.18px'}}
              className='p-10 mt-3 text-center'
            >
              <img
                src={require('../../assets/img/empty-register.png')}
                alt='PANA'
                className='img-fluid'
                style={{height: 'auto', width: '8%'}}
              />
              <p className='h6 mt-5'>Belum ada data pendaftaran</p>
              <p>
                Saat ini, kami belum menemukan data pendaftaran Anda. Silakan lakukan pendaftaran
                terlebih dahulu untuk melanjutkan.
              </p>
            </div>
          )}
        </div>

        <div
          className='d-flex flex-column flex-md-row justify-content-between align-items-center p-4 p-md-5 mt-4 rounded mt-8'
          style={{
            background: 'linear-gradient(90deg, #F95E2F 0%, #FDC830 100%)',
            color: 'white',
            minHeight: '200px',
          }}
        >
          {/* Kiri: Teks dan Tombol */}
          <div className='text-center text-md-start mb-4 mb-md-0 px-2 px-md-4'>
            <p className='text-white h1 fw-bold mb-2'>Panduan Pendaftaran</p>
            <p className='mb-4 text-white fw-bold'>Panduan Pendaftaran & Syarat Ketentuan</p>
            <button
              onClick={() => handleShowGuideModal(true)}
              className='btn btn-light text-primary mt-5 fw-bold px-4 py-2 rounded'
            >
              Lihat Selengkapnya
            </button>
          </div>

          {/* Kanan: Gambar ilustrasi */}
          <div className='text-center px-2 px-md-4'>
            <img
              src={ImageNote}
              alt='Panduan'
              style={{
                maxHeight: '150px',
                width: '100%',
                maxWidth: '250px',
                objectFit: 'contain',
              }}
            />
          </div>
        </div>

        {themeList?.length > 0 ? (
          <div className='mt-8'>
            <p className='h4 pb-3'>Informasi Tema Pengabdian Saat Ini</p>
            <div style={{background: '#FFFFFF', borderRadius: '6.18px'}} className='p-8 mt-3'>
              {themeList?.map((theme: any, index: number) => {
                return (
                  <div
                    key={index}
                    className={`card border p-7 ${index > 0 ? 'mt-5' : ''}`}
                    style={{cursor: 'pointer', boxShadow: '0 2px 8px rgba(0,0,0,0.08)'}}
                    onClick={() =>
                      (dataPana?.pendaftaran_locus_temas?.length > 0 || dataPana?.nomor_pendaftaran)
                        ? null
                        : handleShowRegisterModal(true)
                    }
                  >
                    {/* Header Section */}
                    <div className='mb-4'>
                      <h5 className='mb-3' style={{color: '#181C32', fontWeight: '600'}}>
                        {theme?.nama}
                      </h5>
                      <p className='mb-0' style={{fontSize: '14px', color: '#181C32'}}>
                        <span className='fw-bold'>Periode:</span>{' '}
                        {`${theme?.tanggal_mulai} - ${theme?.tanggal_akhir}`}
                      </p>
                    </div>

                    <div className='mb-4' style={{borderTop: '2px solid #E4E6EF'}} />

                    {/* Description Section */}
                    <div className='mb-4'>
                      <p style={{fontSize: '14px', color: '#3F4254', lineHeight: '1.8', textAlign: 'justify'}}>
                        Program Alumni Pejuang Digital adalah kolaborasi Kemendikdasmen dan LPDP untuk mempercepat 
                        digitalisasi pembelajaran di sekolah wilayah 3T dan Daerah Khusus. Alumni LPDP berperan sebagai 
                        Pejuang Digital yang mendampingi guru selama 3 bulan secara intensif. Fokus pendampingan meliputi 
                        pemanfaatan perangkat teknologi dan Papan Interaktif Digital (PID), penggunaan bahan ajar digital, 
                        penerapan pembelajaran interaktif, peningkatan kompetensi guru, serta penguatan manajerial sekolah, 
                        guna mendorong transformasi dari pembelajaran konvensional menuju ekosistem pembelajaran digital 
                        yang berkelanjutan.
                      </p>
                    </div>

                    {/* Button Section */}
                    {(dataPana?.pendaftaran_locus_temas?.length > 0 || dataPana?.nomor_pendaftaran) ? null : (
                      <div className='d-flex justify-content-end mt-4'>
                        <button
                          className='btn btn-primary fw-bold px-5'
                          style={{backgroundColor: '#F95E2F', borderColor: '#F95E2F'}}
                          onClick={(e) => {
                            e.stopPropagation()
                            handleShowRegisterModal(true)
                          }}
                        >
                          Daftar Sekarang!
                        </button>
                      </div>
                    )}
                  </div>
                )
              })}
            </div>
          </div>
        ) : (
          <div className='mt-8'>
            <p className='h4 pb-3'>Informasi Tema Pengabdian Saat ini</p>
            <div
              style={{background: '#FFFFFF', borderRadius: '6.18px'}}
              className='p-10 mt-3 text-center'
            >
              <img
                src={require('../../assets/img/empty-pana.png')}
                alt='PANA'
                className='img-fluid'
                style={{height: 'auto', width: '8%'}}
              />
              <p className='h6 mt-5'>Belum Ada Informasi Tema Pengabdian</p>
              <p>
                Saat ini, belum ada informasi tema pengabdian yang tersedia untuk Anda. Silakan
                lakukan pendaftaran atau perbarui profil Anda untuk mendapatkan informasi terbaru.
              </p>
            </div>
          </div>
        )}
      </div>
    </>
  )
}

const Beranda: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'PANA',
            path: '/pana-beranda',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '/',
            path: '',
            isSeparator: false,
            isActive: false,
          },
        ]}
      >
        Beranda
      </PageTitle>
      <BerandaPage />
    </>
  )
}

export default Beranda
